import React from 'react';

import {Grid, GridColumn as Column, GridColumnMenuItemGroup} from '@progress/kendo-react-grid';
import {process, toDataSourceRequestString, translateDataSourceResultGroups} from '@progress/kendo-data-query';

import products from './products.json';
import Config from "../../_helpers/config";
import {authHeader} from "../../_helpers/auth-header";
import GridToCheck from "../../components/stock/GridTocheck";
import {GridHeaderSelectionCell} from "@progress/kendo-react-grid/dist/npm/header/GridHeaderSelectionCell";
import {GridSelectionCell} from "@progress/kendo-react-grid/dist/npm/cells/GridSelectionCell";

class GridTest extends React.Component {
    aggregates = [
        { field: 'listNumberAndRemarks', aggregate: 'count' }
    ];

    state = this.createAppState({
        skip: 0,
        take: 100000,
        group: [
            { field: 'listNumberAndRemarks' }
        ]
    });

    render() {
        return (
            <Grid
                style={{ height: '520px' }}
                filterable={false}
                sortable={false}
                pageable={false}
                groupable={{ footer: 'visible' }}

                data={this.state.result}
                {...this.state.dataState}
                onDataStateChange={this.dataStateChange}

                onExpandChange={this.expandChange}
                expandField="expanded"
                cellRender={this.cellRender}
            >


                <Column field="description" title="description" />
                <Column field="quantity" title="Quantity" filter="numeric" />
            </Grid>
        );
    }

    createAppState(dataState) {
        const groups = dataState.group;
        if (groups) { groups.map(group => group.aggregates = this.aggregates); }
        return {

            dataState: dataState
        };
    }
    componentDidMount() {
      this.fetchData(this.state.dataState);
    }
    fetchData(dataState) {
        const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state
        const hasGroups = dataState.group && dataState.group.length;



        const base_url = `${Config.ApiUrl}/stock/todo`;
        const init = { method: 'GET', accept: 'application/json', headers: authHeader() };

        fetch(`${base_url}?${queryStr}`, init)
            .then(response => response.json())
            .then(({ data, total }) => {
                this.setState({
                    result: hasGroups ? translateDataSourceResultGroups(data) : data,
                    total: total,
                    dataState : dataState
                });
            });
    }
    selectionChange = (event) => {
        console.log("selection changed");
        console.log(event);
    }
    dataStateChange = (event) => {
        this.setState(this.createAppState(event.data));
    }

    expandChange = (event) => {
        event.dataItem[event.target.props.expandField] = event.value;
        console.log("expanding change");
        this.setState({
            result: this.state.result,
            dataState: this.state.dataState
        });
    }



    cellRender = (td, props) => {

            if (props.rowType === 'groupFooter') {
                return(<td style={{display: 'none'}}/>);
            }

        if (td && td.props.children && props.rowType === "groupHeader") {
            let children = <span>
        {/*<span style={{ width: this.firstColumnWidth, float: "left" }}>{td.props.children.props.children}</span>*/}
        <span className="customGroupHeader">
          <a href="#"
             tabIndex="-1"
             className={props.expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'}
             onClick={(e) => {
                 e.preventDefault();
                 if (props.onChange) {
                     props.onChange({
                         dataItem: props.dataItem,
                         syntheticEvent: e,
                         field: undefined,
                         value: !props.expanded
                     });
                 }
             }}></a>
            {/*<FormControlLabel*/}
                {/*control={*/}
                    {/*<Checkbox*/}
                        {/*icon={<CheckBoxOutlineBlankIcon fontSize="small" />}*/}
                        {/*checkedIcon={<CheckBoxIcon fontSize="small" />}*/}
                        {/*value="false" onChange={handleSend(props.dataItem.items)}*/}
                    {/*/>*/}
                {/*}*/}
                {/*label="Verzonden"*/}
            {/*/>*/}

            {props.dataItem.value} ({props.dataItem.items.length})
            </span>

      </span >
            return React.cloneElement(td, td.props, children);
        }
        return td
    }








    // cellRender(tdElement, cellProps) {
    //     console.log(cellProps);
    //     if (cellProps.rowType === 'groupFooter') {
    //         return("");
    //     }
    //     if (cellProps.rowType === 'groupHeader') {
    //         if (cellProps.field === 'value') {
    //
    //
    //             return (
    //
    //
    //                 // <td colSpan={3}>
    //                 //     {} - Aantal: {cellProps.dataItem.items.length}
    //                 // </td>
    //             );
    //         } else if (cellProps.field === 'UnitsInStock') {
    //
    //             return (
    //                 <td>
    //                     Sum: {cellProps.dataItem.aggregates.UnitsInStock.sum}
    //                 </td>
    //             );
    //         }
    //     }
    //     return tdElement;
    // }
}

export default GridTest;
